import { Body, Headline } from '@Backlot-Cars/archie';
import { HeaderContainer } from './styles';

const SignUpHeader = ({ title, subTitle }) => {
	return (
		<>
			<HeaderContainer>
				{title && <Headline size="H3">{title}</Headline>}
				{subTitle && <Body fontSize="smaller">{subTitle}</Body>}
			</HeaderContainer>
		</>
	);
};

export default SignUpHeader;
